import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { LineItem } from './line-item';

const PrepareDiscountFields = (discount) => {
  const { value, title, max_amount } = discount;
  const applyAs = discount.apply_as;
  const discountAmount = discount.discount_amount;
  const discountDescription = ('PERCENT_OFF' === applyAs)
    ? <FormattedMessage id='inbox.prepare_discount_fields.percent_off' defaultMessage='{value}% off' values={{ value: value }} />
    : <FormattedMessage
      id='inbox.prepare_discount_fields.value_off'
      defaultMessage='{value} off'
      values={{
        value: <FormattedNumber
          value={value}
          currency='USD'
          style={'currency'}
        />
      }}
    />;

  const maxAmountDescripton = max_amount
    ? <FormattedMessage
      id='inbox.prepare_discount_fields.max_amount'
      defaultMessage=', up to {amount}'
      values={{
        amount: <FormattedNumber
          value={max_amount}
          currency='USD'
          style={'currency'}
        />
      }}
    />
    : '';

  return {
    content: discount.discount_str ? discount.discount_str :
      (
        <div>
          <div>{title}</div>
          <div>({discountDescription}{maxAmountDescripton})</div>
        </div>
      ),
    value: parseFloat(discountAmount).toFixed(2)
  };
};

const BorderBottomLineItem = () => {
  return (
    <LineItem
      label={{ }}
      value={{ }}
      optionalValue={{ }}
      customClass="summary-line"
    />
  );
};

const BorderTopLineItem = () => {
  return (
    <LineItem
      label={{ }}
      value={{ }}
      optionalValue={{ }}
      customClass="top-summary-line"
    />
  );
};

const RevisedCalculator = (props) => {
  return (
    <table style={{ width: '100%' }}>
      <tbody>{props.children}</tbody>
    </table>
  );
};

const TableLabel = ({ firstCaption, secondCaption, rowClass = '', attributes = {} }) => {
  return (
    <tr className={`line-item ${rowClass}`} style={{ color: 'inherit' }} {...attributes}>
      <td className={firstCaption.optionalClass || null }>
        {firstCaption.value}
      </td>
      <td />
      <td className={secondCaption.optionalClass || null }>
        {secondCaption.value}
      </td>
    </tr>
  );
};

export {
  BorderBottomLineItem,
  BorderTopLineItem,
  PrepareDiscountFields,
  RevisedCalculator,
  TableLabel
};

